module.exports = "/desktop-app/assets/img/mail.svg?8a98e9827acc94db628341f9b984ed1f";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/svg/mail.svg
// module id = m68y
// module chunks = 1